'use strict';

var _ = require('lodash');
var AttributeConstraintValues = require('./../index');
let AttributeEvaluationResponse = require('./../../../AttributeEvaluationResponse/index');

module.exports = class RuleConstraintValues extends AttributeConstraintValues {
    /**
     * See parent for details.
     * @param  {Object} config The configuration to build with.
     */
    constructor(config) {
        validate(config);

        super(config);

        // false values will be evaluated again, once it evaluates to true it stops being checked
        this._evaluateState = false;
    }

    /**
     * Evalutes the current rule based on the provided attributeSelection.
     *
     * @param  {Object} attributeSelection The attribute selection to evaluate.
     * @return {bool} true if and only if this attribute is valid through the evaluation of attributeSelection.
     */
    evaluate(attributeSelection) {
        let result = super.evaluate(attributeSelection);
        this._evaluateState = result;

        return new AttributeEvaluationResponse(this._key, result, this._evaluateState);
    }
};

function validate(config) {
    if (_.isNil(config)) {
        throw new Error('config must not be null or undefined.');
    }

    if (_.isNil(config.negate)) {
        throw new Error('config.negate must not be null or undefined.');
    }
}
